import { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import { useParams } from "react-router-dom";
import { TbEdit } from "react-icons/tb";
import { AiFillDelete } from "react-icons/ai";
import { BsPlusCircleFill } from "react-icons/bs";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import api from "../../../api/axiosInstance";

const OperatorRoles = (props) => {
  const { operatorId, onRolesUpdated } = props;
  const pId = useParams();
  const [isEdit, setIsEdit] = useState(false);
  const [showAddRole, setShowAddRole] = useState(false);
  const [operatorRoles, setOperatorRoles] = useState([]);
  const [operatorRole, setOperatorRole] = useState({});
  const [schools, setSchools] = useState([]);
  const [errors, setErrors] = useState({});
  
  // Ref for focusing on error field
  const roleNameRef = useRef(null);

  const handleCloseAddRole = () => {
    setShowAddRole(false);
    setErrors({});
    setOperatorRole({});
  };
  const handleShowAddRole = () => {
    setShowAddRole(true);
    setErrors({});
    setOperatorRole({});
  };

  const handleShow = (role) => {
    setIsEdit(true);
    setErrors({});
    
    // Set all role data at once to ensure it's available when modal opens
    const roleData = {
      ...role,
      operatorRoleId: role.roleId,
      operatorId: pId.OperatorId,
    };
    
    // If school level role, set school selection for the Select component
    if (role.schoolId && role.schoolId !== 0 && role.schoolId !== null) {
      const selectedSchool = schools.find(school => school.value === role.schoolId || school.value === parseInt(role.schoolId));
      if (selectedSchool) {
        roleData.school = selectedSchool; // Select expects a single object, not an array
      }
    } else {
      // Ensure school is undefined/null for operator level roles
      roleData.school = undefined;
    }
    
    // Set the role data first, then show the modal
    setOperatorRole(roleData);
    setShowAddRole(true);
  };

  const deleteRole = () => {};

  const getSchools = () => {
    var config = {
      method: "Get",
      url:
        process.env.REACT_APP_API_URL +
        "Schools/GetDLLSchoolsByOperator/" +
        pId.OperatorId,
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config).then(function (response) {
      if (response.data.statusCode === 200) {
        setSchools(response.data.content);
      }
    });
  };

  const AddRole = () => {
    // Validate required fields before submission
    const validationErrors = {};
    let hasErrors = false;

    if (!operatorRole.roleName || operatorRole.roleName.trim() === '') {
      validationErrors.RoleName = ['The RoleName field is required.'];
      hasErrors = true;
    }

    if (hasErrors) {
      setErrors(validationErrors);
      // Focus on the role name field
      setTimeout(() => {
        if (roleNameRef.current) {
          roleNameRef.current.focus();
        }
      }, 100);
      toast.warning("Please review and correct the required fields");
      return;
    }

    // Clear errors if validation passes
    setErrors({});

    var config = {
      method: "post",
      url: process.env.REACT_APP_API_URL + "Roles/AddRoles",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      data: operatorRole,
    };

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          toast.success("Role Added Successfully");
          setShowAddRole(false);
          setOperatorRoles([]);
          setOperatorRole({});
          setErrors({});
          getOperatorRoles();
          // Notify parent component that roles have been updated
          if (onRolesUpdated) {
            onRolesUpdated();
          }
        } else if (response.data.statusCode === 403) {
          toast.error(response.data.message || "Unthorized, please check support.");
        } else {
          toast.error("Role Already Exists");
        }
      })
      .catch(function (error) {
        if (error?.response?.data?.errors) {
          const validationErrors = error.response.data.errors;
          setErrors(validationErrors);
          setTimeout(() => {
            if (roleNameRef.current) {
              roleNameRef.current.focus();
            }
          }, 100);
          toast.warning("Please review and correct the required fields");
        } else {
          toast.error(error?.response?.data?.message || "Failed to add role");
        }
      });
  };

  const EditRole = () => {
    // Validate required fields before submission
    const validationErrors = {};
    let hasErrors = false;

    if (!operatorRole.roleName || operatorRole.roleName.trim() === '') {
      validationErrors.RoleName = ['The RoleName field is required.'];
      hasErrors = true;
    }

    if (hasErrors) {
      setErrors(validationErrors);
      // Focus on the role name field
      setTimeout(() => {
        if (roleNameRef.current) {
          roleNameRef.current.focus();
        }
      }, 100);
      toast.warning("Please review and correct the required fields");
      return;
    }

    // Clear errors if validation passes
    setErrors({});

    console.log(operatorRole)
    var config = {
      method: "put",
      url: process.env.REACT_APP_API_URL + "Roles/UpdateRole",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      data: operatorRole,
    };

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          toast.success("Role Updated Successfully");
          setShowAddRole(false);
          setOperatorRoles([]);
          setOperatorRole({});
          setErrors({});
          getOperatorRoles();
          // Notify parent component that roles have been updated
          if (onRolesUpdated) {
            onRolesUpdated();
          }
        }
      })
      .catch(function (error) {
        if (error?.response?.data?.errors) {
          const validationErrors = error.response.data.errors;
          setErrors(validationErrors);
          setTimeout(() => {
            if (roleNameRef.current) {
              roleNameRef.current.focus();
            }
          }, 100);
          toast.warning("Please review and correct the required fields");
        } else {
          toast.error(error?.response?.data?.message || "Failed to update role");
        }
      });
  };

  const getOperatorRoles = () => {
    var isOperator = localStorage.getItem("O3rt!05");
    var config = {};
    if (isOperator) {
      var operatorId = localStorage.getItem("oTsReD");
      config = {
        method: "Get",
        url:
          process.env.REACT_APP_API_URL +
          "Operators/GetOperatorRoles/" +
          operatorId,
        headers: {
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
    } else {
      config = {
        method: "Get",
        url:
          process.env.REACT_APP_API_URL +
          "Operators/GetOperatorRoles/" +
          pId.OperatorId,
        headers: {
          "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
    }

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          setOperatorRoles(response.data.content);
          if (response.data.content.roleLevel == true) {
            setOperatorRole((prevState) => ({
              ...prevState,
              type: "school",
            }));
          }
        }
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          window.location = "/Login";
          window.location.reload();
        }
      });
  };

  const columns = [
    {
      name: "Role Name",
      selector: (row) => row.roleName,
    },
    {
      name: "Options",
      selector: (row) => (
        <>
          <button
            className="btn btn-icon btn-sm btn-warning cts-btn-warning mr-5"
            onClick={() => handleShow(row)}
          >
            <TbEdit />
          </button>
          {/* <button
            className="btn btn-icon btn-sm btn-danger cts-btn-danger mr-5"
            onClick={() => deleteRole()}
          >
            <AiFillDelete />
          </button> */}
        </>
      ),
      width: "190px",
    },
  ];
  useEffect(() => {
    getOperatorRoles();
    getSchools();
    setOperatorRole((prevState) => ({
      ...prevState,
      type: "operator",
    }));

    setOperatorRole((prevState) => ({
      ...prevState,
      operatorId: pId.OperatorId,
    }));
  }, []);
  return (
    <>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Operator & School Roles</h3>
          <div className="align-self-center">
            <button
              className="btn btn-primary btn-sm cts-btn-primary d-flex align-items-center gap-2"
              onClick={() => {
                handleShowAddRole();
                setOperatorRole({});
                setOperatorRole((prevState) => ({
                  ...prevState,
                  operatorId: pId.OperatorId,
                }));
                setOperatorRole((prevState) => ({
                  ...prevState,
                  type: "operator",
                }));
              }}
            >
              <BsPlusCircleFill size={16} />
              Add Role
            </button>
          </div>
        </div>
        <div className="card-body p-0">
          <DataTable columns={columns} data={operatorRoles} pagination={true} />
        </div>
      </div>
      <Modal show={showAddRole} onHide={handleCloseAddRole} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Role: {operatorRole.roleName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row ">
              <div className="col-12 mb-20">
                <label>Role Name <span className="text-danger">*</span></label>
                <input
                  ref={roleNameRef}
                  className={`form-control form-control-sm ${errors.RoleName ? 'is-invalid' : ''}`}
                  value={operatorRole.roleName || ''}
                  onChange={(e) => {
                    setOperatorRole((prevState) => ({
                      ...prevState,
                      roleName: e.target.value,
                    }));
                    // Clear error when user starts typing
                    if (errors.RoleName) {
                      setErrors((prevErrors) => {
                        const newErrors = { ...prevErrors };
                        delete newErrors.RoleName;
                        return newErrors;
                      });
                    }
                  }}
                ></input>
                {errors.RoleName && (
                  <div className="text-warning" style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>
                    {errors.RoleName[0]}
                  </div>
                )}
              </div>
              <div className="col-12 mb-20">
                <h5>Role Type</h5>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    checked={
                      operatorRole.schoolId != 0 &&
                      operatorRole.schoolId != null
                        ? false
                        : true
                    }
                    onChange={(e) => {
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        schoolId: 0,
                      }));
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        operatorId: pId.OperatorId,
                      }));
                    }}
                  />
                  <label className="form-check-label" for="inlineRadio1">
                    Operator Level
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    checked={
                      operatorRole.schoolId != 0 &&
                      operatorRole.schoolId != null
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        schoolId: 9999,
                      }));
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        operatorId: pId.OperatorId,
                      }));
                    }}
                  />
                  <label className="form-check-label" for="inlineRadio2">
                    School Level
                  </label>
                </div>
              </div>
              {operatorRole.schoolId != 0 && operatorRole.schoolId != null && (
                <div className="col-12 mb-20">
                  <Select
                    options={schools}
                    value={operatorRole.school}
                    placeholder="Select School"
                    onChange={(e) => {
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        school: e,
                      }));
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        schoolId: e.value,
                      }));
                    }}
                  ></Select>
                </div>
              )}
              <div className="col-12">
                <hr></hr>
                <h5>Permissions</h5>
                <hr></hr>
              </div>
              <div className="col-12">
                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                  <input
                    className="form-check-input h-20px w-30px"
                    type="checkbox"
                    id="viewDashboards"
                    checked={operatorRole.viewDashboard}
                    onChange={(e) =>
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        viewDashboard: e.target.checked,
                      }))
                    }
                  />
                  View Dashboard
                  </div>
                <hr></hr>
              </div>
              <div className="col-4">
                <h6>Students</h6>
                <div className="col-12">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      id="viewStudents"
                      checked={operatorRole.viewStudents}
                      onChange={(e) =>
                        setOperatorRole((prevState) => ({
                          ...prevState,
                          viewStudents: e.target.checked,
                        }))
                      }
                    />
                    <label className="form-check-label" for="usersView">
                      View
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      id="usersView"
                      checked={operatorRole.exportStudents}
                      onChange={(e) =>
                        setOperatorRole((prevState) => ({
                          ...prevState,
                          exportStudents: e.target.checked,
                        }))
                      }
                    />
                    <label className="form-check-label" for="usersView">
                      Export
                    </label>
                  </div>
                </div>
                {/* <div className="col-12">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      id="usersView"
                      checked={operatorRole.editUser}
                      onChange={(e) =>
                        setOperatorRole((prevState) => ({
                          ...prevState,
                          editUser: e.target.checked,
                        }))
                      }
                    />
                    <label className="form-check-label" for="usersView">
                      Edit
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      id="usersView"
                      checked={operatorRole.deleteUser}
                      onChange={(e) =>
                        setOperatorRole((prevState) => ({
                          ...prevState,
                          deleteUser: e.target.checked,
                        }))
                      }
                    />
                    <label className="form-check-label" for="usersView">
                      Delete
                    </label>
                  </div>
                </div> */}
              </div>
              <div className="col-4">
                <h6>Teachers</h6>
                <div className="col-12">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      id="viewTeachers"
                      checked={operatorRole.viewTeachers}
                      onChange={(e) =>
                        setOperatorRole((prevState) => ({
                          ...prevState,
                          viewTeachers: e.target.checked,
                        }))
                      }
                    />
                    <label className="form-check-label" for="viewTeachers">
                      View
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      id="exportTeachers"
                      checked={operatorRole.exportTeachers}
                      onChange={(e) =>
                        setOperatorRole((prevState) => ({
                          ...prevState,
                          exportTeachers: e.target.checked,
                        }))
                      }
                    />
                    <label className="form-check-label" for="exportTeachers">
                      Export
                    </label>
                  </div>
                </div>
                {/* <div className="col-12">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      id="editRole"
                      checked={operatorRole.editRole}
                      onChange={(e) =>
                        setOperatorRole((prevState) => ({
                          ...prevState,
                          editRole: e.target.checked,
                        }))
                      }
                    />
                    <label className="form-check-label" for="editRole">
                      Edit
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      id="deleteRole"
                      checked={operatorRole.deleteRole}
                      onChange={(e) =>
                        setOperatorRole((prevState) => ({
                          ...prevState,
                          deleteRole: e.target.checked,
                        }))
                      }
                    />
                    <label className="form-check-label" for="deleteRole">
                      Delete
                    </label>
                  </div>
                </div> */}
              </div>
              <div className="col-4">
                <h6>Courses</h6>
                <div className="col-12">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      id="viewCourses"
                      checked={operatorRole.viewCourses}
                      onChange={(e) =>
                        setOperatorRole((prevState) => ({
                          ...prevState,
                          viewCourses: e.target.checked,
                        }))
                      }
                    />
                    <label className="form-check-label" for="viewCourses">
                      View
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      id="exportCourses"
                      checked={operatorRole.exportCourses}
                      onChange={(e) =>
                        setOperatorRole((prevState) => ({
                          ...prevState,
                          exportCourses: e.target.checked,
                        }))
                      }
                    />
                    <label className="form-check-label" for="exportCourses">
                      Export
                    </label>
                  </div>
                </div>
                {/* <div className="col-12">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      id="editRole"
                      checked={operatorRole.editSchool}
                      onChange={(e) =>
                        setOperatorRole((prevState) => ({
                          ...prevState,
                          editSchool: e.target.checked,
                        }))
                      }
                    />
                    <label className="form-check-label" for="editRole">
                      Edit
                    </label>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-check form-switch form-check-custom form-check-solid me-10">
                    <input
                      className="form-check-input h-20px w-30px"
                      type="checkbox"
                      id="deleteRole"
                      checked={operatorRole.deleteSchool}
                      onChange={(e) =>
                        setOperatorRole((prevState) => ({
                          ...prevState,
                          deleteSchool: e.target.checked,
                        }))
                      }
                    />
                    <label className="form-check-label" for="deleteRole">
                      Delete
                    </label>
                  </div>
                </div> */}
              </div>
              <div className="col-12">
                <hr></hr>
              </div>
            </div>
            {/* <div className="operatorRole">
              <div className="col-12">
                <h5>Dashboard</h5>
                <hr></hr>
              </div>
              <div className="col-12">
                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                  <input
                    className="form-check-input h-20px w-30px"
                    type="checkbox"
                    id="usersView"
                    checked={operatorRole.kpi210}
                    onChange={(e) =>
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        kpi210: e.target.checked,
                      }))
                    }
                  />
                  <label className="form-check-label" for="usersView">
                    Graded assignments vs Completed Assignments{" "}
                    <small>"KPI-2, KPI10"</small>
                  </label>
                </div>
              </div>
              <div className="col-12">
                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                  <input
                    className="form-check-input h-20px w-30px"
                    type="checkbox"
                    id="addRole"
                    checked={operatorRole.kpi19}
                    onChange={(e) =>
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        kpi19: e.target.checked,
                      }))
                    }
                  />
                  <label className="form-check-label" for="addRole">
                    Assignments with Learning Outcomes <small>"KPI 19"</small>
                  </label>
                </div>
              </div>
              <div className="col-12">
                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                  <input
                    className="form-check-input h-20px w-30px"
                    type="checkbox"
                    id="editRole"
                    checked={operatorRole.kpi7}
                    onChange={(e) =>
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        kpi7: e.target.checked,
                      }))
                    }
                  />
                  <label className="form-check-label" for="editRole">
                    Logged Students vs Total Number <small>"KPI 7"</small>
                  </label>
                </div>
              </div>
              <div className="col-12">
                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                  <input
                    className="form-check-input h-20px w-30px"
                    type="checkbox"
                    id="editRole"
                    checked={operatorRole.kpi18}
                    onChange={(e) =>
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        kpi18: e.target.checked,
                      }))
                    }
                  />
                  <label className="form-check-label" for="editRole">
                    Total Learning Outcomes Linked to Assignments{" "}
                    <small>"KPI 18"</small>
                  </label>
                </div>
              </div>
              <div className="col-12">
                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                  <input
                    className="form-check-input h-20px w-30px"
                    type="checkbox"
                    id="editRole"
                    checked={operatorRole.kpi8}
                    onChange={(e) =>
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        kpi8: e.target.checked,
                      }))
                    }
                  />
                  <label className="form-check-label" for="editRole">
                    Student's Viewing Unique Grades <small>"KPI 8"</small>
                  </label>
                </div>
              </div>
              <div className="col-12">
                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                  <input
                    className="form-check-input h-20px w-30px"
                    type="checkbox"
                    id="editRole"
                    checked={operatorRole.kpi14}
                    onChange={(e) =>
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        kpi14: e.target.checked,
                      }))
                    }
                  />
                  <label className="form-check-label" for="editRole">
                    Never Logged Teachers <small>"KPI 14"</small>
                  </label>
                </div>
              </div>
              <div className="col-12">
                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                  <input
                    className="form-check-input h-20px w-30px"
                    type="checkbox"
                    id="editRole"
                    checked={operatorRole.kpi6}
                    onChange={(e) =>
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        kpi6: e.target.checked,
                      }))
                    }
                  />
                  <label className="form-check-label" for="editRole">
                    Never Logged Students <small>"KPI 6"</small>
                  </label>
                </div>
              </div>
              <div className="col-12">
                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                  <input
                    className="form-check-input h-20px w-30px"
                    type="checkbox"
                    id="editRole"
                    checked={operatorRole.kpi15}
                    onChange={(e) =>
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        kpi15: e.target.checked,
                      }))
                    }
                  />
                  <label className="form-check-label" for="editRole">
                    <small>"KPI 15"</small>
                  </label>
                </div>
              </div>
              <div className="col-12">
                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                  <input
                    className="form-check-input h-20px w-30px"
                    type="checkbox"
                    id="editRole"
                    checked={operatorRole.kpi16}
                    onChange={(e) =>
                      setOperatorRole((prevState) => ({
                        ...prevState,
                        kpi16: e.target.checked,
                      }))
                    }
                  />
                  <label className="form-check-label" for="editRole">
                    <small>"KPI 16"</small>
                  </label>
                </div>
              </div>
            </div> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-sm btn-secondary cts-btn-secondary"
            onClick={handleCloseAddRole}
          >
            Close
          </button>
          {isEdit ? (
            <button
              className="btn btn-sm btn-primary cts-btn-primary"
              onClick={() => EditRole()}
            >
              Update Role
            </button>
          ) : (
            <button
              className="btn btn-sm btn-primary cts-btn-primary"
              onClick={() => AddRole()}
            >
              Save Changes
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OperatorRoles;
